import { ArrowBackIcon } from "@/components/appIcons";
import { Link } from "@/components/link";

/**
 * Mobile replacement for the detail-page breadcrumb: a single "up" link. The full
 * breadcrumb (which wraps to two lines on phones) is shown from `md` up.
 */
export function DetailBackLink({ to, label }: { to: string; label: string }) {
  return (
    <Link
      to={to}
      className="mb-5 inline-flex min-h-11 max-w-full items-center gap-2 text-sm font-medium text-muted-foreground hover:text-foreground md:hidden"
    >
      <ArrowBackIcon className="text-base" decorative />
      <span className="min-w-0 truncate">{label}</span>
    </Link>
  );
}
